// extracted by mini-css-extract-plugin
export default {"container":"FloatingButtonWhatsApp_container__+uNB2","buttonIcon":"FloatingButtonWhatsApp_buttonIcon__JRfnQ"};